import { kebabCase } from 'lodash-es';
import I18n from 'utils/I18n';

export const t = (key, params) =>
  I18n.t(`components.onboarding.${key}`, { ...params });

export const stepToUrl = ({ page, step }) => {
  const prefix = page === 'consents' ? '/athlete' : '';
  return `${prefix}/${page}/${kebabCase(step)}`;
};

export default { t, stepToUrl };
